module.exports = __webpack_public_path__ + "bd6046e03b3521b5de6d5fa61216dcf7.svg";